"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const _1 = require("./../");
exports.DatagridMapView = (props) => (React.createElement(_1.Row, { className: "bkn-datagrid-map" }, props.children));
exports.DatagridMapView.displayName = 'DatagridMapView';



//////////////////
// WEBPACK FOOTER
// ./src/components/Datagrid/DatagridMapView.tsx
// module id = 255
// module chunks = 0